import React from 'react';

interface LinkProps {
  href: string;
  children: React.ReactNode;
  className?: string;
}

export const Link: React.FC<LinkProps> = ({ href, children, className = '' }) => {
  return (
    <a 
      href={href}
      className={`text-gray-600 hover:text-indigo-600 font-medium transition-colors ${className}`}
    >
      {children}
    </a>
  );
};

interface ButtonProps {
  primary?: boolean;
  disabled?: boolean;
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
}

export const Button: React.FC<ButtonProps> = ({
  primary = false,
  disabled,
  children,
  onClick,
  className = ''
}) => {
  const baseClasses = "flex justify-center items-center px-8 py-4 rounded-full font-semibold text-lg transition-all duration-300 transform hover:-translate-y-0.5 focus:outline-none focus:ring-4 focus:ring-offset-2 active:translate-y-0";
  const primaryClasses = "bg-gradient-to-r from-indigo-600 to-indigo-500 text-white hover:from-indigo-500 hover:to-indigo-400 shadow-lg hover:shadow-xl focus:ring-indigo-500/50";
  const secondaryClasses = "bg-white text-indigo-600 border-2 border-indigo-100 hover:border-indigo-200 hover:bg-indigo-50 shadow-lg hover:shadow-xl focus:ring-indigo-500/30";
  const disabledClasses = "opacity-50 cursor-not-allowed";

  return (
      <button
          disabled={disabled}
          onClick={onClick}
          className={`${baseClasses} ${primary ? primaryClasses : secondaryClasses} ${disabled ? disabledClasses : ''} ${className}`}
      >
        {children}
      </button>
  );
};
